/* global console window EyeDropper */
import * as React from "react";
import { useState } from "react";
import PropType from "prop-types";
import { useTranslation } from "react-i18next";
import { Input } from "@fluentui/react-components";
import CommonTooltip from "../../common/CommonTooltip";
import { HexColorPicker } from "react-colorful";
import { Eyedropper20Filled } from "@fluentui/react-icons";
import TrackedButton from "../../common/TrackedButton";

const CustomColorPickerSubMenu = (props) => {
  const { t } = useTranslation();
  const [selectedColor, setSelectedColor] = useState(props.color);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateRows: "auto auto",
        gap: 8,
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {/* First row with two columns */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "auto auto",
          gap: 8,
        }}
      >
        {/* First column with four rows */}
        <div
          style={{
            display: "grid",
            gridTemplateRows: "auto auto auto 1fr",
            alignContent: "start",
          }}
        >
          {/* Current color */}
          <div>
            {t("menu.colors.current")}
            <div
              style={{
                background: props.color ?? "black",
                height: 20,
              }}
            />
          </div>

          {/* New color */}
          <div>
            <div
              style={{
                background: selectedColor ?? "black",
                height: 20,
              }}
            />
            {t("menu.colors.new")}
          </div>

          {/* Color input and eye dropper */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr auto",
              gap: 4,
              paddingTop: 8,
            }}
          >
            <Input
              id={`color_${props.color.name}`}
              placeholder={t("menu.colors.hex.placeholder")}
              value={selectedColor}
              onChange={(e, data) => {
                setSelectedColor(data.value);
              }}
              style={{
                minWidth: 0,
                width: 100,
              }}
            />

            {window.EyeDropper ? (
              <CommonTooltip content={t("menu.colors.eye-dropper.tooltip")}>
                <TrackedButton
                  icon={<Eyedropper20Filled />}
                  onClick={() => {
                    if (window.EyeDropper) {
                      const eyeDropper = new EyeDropper();
                      eyeDropper
                        .open()
                        .then((result) => {
                          setSelectedColor(result.sRGBHex);
                        })
                        .catch((e) => {
                          console.log("eye dropper error", e);
                        });
                    }
                  }}
                >
                  {t("menu.colors.eye-dropper")}
                </TrackedButton>
              </CommonTooltip>
            ) : (
              <></>
            )}
          </div>

          {/* Second row with detected colors as selector buttons */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: 4,
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            {props.detectedColors.slice(2).map((color) => (
              <CommonTooltip
                key={color.key}
                content={t("menu.colors.detected", { hex: color.key, count: color.count })}
                positioning="after"
              >
                <TrackedButton
                  id="detected_color_button"
                  appearance="subtle"
                  style={{
                    background: color.key,
                    border: color.key === "#FFFFFF" ? "1px solid black" : undefined,
                    width: 16,
                    height: 16,
                    minWidth: 0,
                  }}
                  onClick={() => setSelectedColor(color.key)}
                />
              </CommonTooltip>
            ))}
          </div>
        </div>

        {/* Second column with color picker */}
        <div style={{ padding: 8, maxWidth: 256 }}>
          <HexColorPicker
            color={selectedColor?.length === 7 ? selectedColor : props.color}
            onChange={(newColor) => setSelectedColor(newColor)}
          />
        </div>
      </div>

      {/* Third row with apply button spanning full width */}
      <TrackedButton
        id="apply_color_button"
        onClick={() => {
          if (props.onClose) {
            props.onClose();
          }
          props.onNewColor(selectedColor, "");
        }}
        style={{
          width: "100%",
          backgroundColor: "#0065FD",
          color: "white",
        }}
      >
        {t("menu.colors.apply")}
      </TrackedButton>
    </div>
  );
};

CustomColorPickerSubMenu.propTypes = {
  onNewColor: PropType.func.isRequired,
  color: PropType.string,
  onClose: PropType.func,
  detectedColors: PropType.array,
};

export default CustomColorPickerSubMenu;
